import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import atividadeSelector from "../store/atividade.selectors";
import cnaeSelector from "../../cnae/store/cnae.selectors";
import decaSelector from "../../../store/deca.selectors";
import atividadeActions from "../store/atividade.actions";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
import { ddadosAtividade as DDados } from "../atividade.ddados";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import api from "../service/atividade.service";
import Panel from "@common/externos/components/panel/panel.component";
import AtividadeGrid from "./atividades.grid";
import Button from "@material-ui/core/Button";
import CpfCnpjValidator from "@common/validators/cpfCnpj.validator";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      blockDoubleClick: true,
    };

    this.arrayAtividadesAssociados = [];
  }

  onSubmit(itens) {
    const { atividades } = this.props.atividadeSelector.atividade;
    var multiplo = atividades.length == 0;
    const promise = new Promise((resolve, reject) => {
      itens.forEach(async (item, index, array) => {
        await this.adicionar(item.data, index == 0 ? multiplo : false);
        if (index === array.length - 1) resolve();
      });
    });

    promise.then(() => {
      if (this.arrayAtividadesAssociados.length > 0) {
        let message;
        const lastIndex = this.arrayAtividadesAssociados.length - 1;
        const lastItem = this.arrayAtividadesAssociados[lastIndex];
        this.arrayAtividadesAssociados.splice(lastIndex, 1);

        if (this.arrayAtividadesAssociados.length > 0) {
          message = this.arrayAtividadesAssociados.join(", ");
          message = `${message} e ${lastItem}`;
        } else message = lastItem;

        _showError(`Esses itens já foram adicionados: ${message}.`);
        this.arrayAtividadesAssociados = [];
      }
    });
  }

  async adicionar(item, multiplo) {
    const { atividades } = this.props.atividadeSelector.atividade;
    let itemAtividade = {
      IdAtividade: item.Id,
      Principal: multiplo,
      CodigoString: item.CodigoAtividade,
      Descricao: item.Descricao,
      IdsCnae: item.IdsCnae,
    };
    if (this.state.blockDoubleClick) {
      if (
        atividades.filter((x) => x.IdAtividade == itemAtividade.IdAtividade)
          .length != 0
      ) {
        this.arrayAtividadesAssociados.push(item.CodigoAtividade);
      } else {
        await this.props.atividadeActions.addSagaAtividade(itemAtividade);
        this.setState({ blockDoubleClick: false });
        setTimeout(
          function () {
            this.setState({ blockDoubleClick: true });
          }.bind(this),
          1000
        );
      }
    }
  }

  render() {
    const { Campos } = DDados;
    const { form, disableAll, isView } = this.props;
    const { deca } = this.props.decaSelector;
    const { parametro } = deca.registrarSolicitacao;
    const { atividade } = this.props.atividadeSelector;
    const { cnae } = this.props.cnaeSelector;
    const { solicitacao } = this.props.solicitacaoSelector;
    const encerramentoDesabilita =
      solicitacao.CCM != undefined && solicitacao.TipoSolicitacao == 3;
    const UtilizarVinculoCNAEAtividadenaSolicitacao = parametro.find(
      (x) => x.Descricao == "UtilizarVinculoCNAEAtividadenaSolicitacao"
    );

    const associacaoAtividade = parametro && parametro.find(x => x.Nome === 'DECACNAEAssociacaoAtividade' && x.Valor === 'S');

    return (
      <Panel title={"Atividades"} defaultExpanded={false}>
        <Row>
          <Col lg={"10"}>
            <DDadosItem
              name="SuggestionAtividade"
              {...Campos.SuggestionAtividade}
              service={api.suggestionAtividade}
              mapTag={(item) => ({
                data: {
                  ...item,
                },
                selectedItem: item.Id + item.CodigoAtividade,
                value: item.Descricao,
                tooltip: item.Descricao,
              })}
              parameters={{

                cnaesVinculados: cnae.Ids,
                UtilizarVinculoCNAEAtividadenaSolicitacao: UtilizarVinculoCNAEAtividadenaSolicitacao
                  ? UtilizarVinculoCNAEAtividadenaSolicitacao.Valor
                  : "N",
              }}
              onChange={(itens) => {
                const data = itens.map((item) => {
                  return item.data;
                });

                this.props.atividadeActions.onChange(data);
              }}
              state={atividade}
              Desabilitado={
                encerramentoDesabilita ||
                disableAll ||
                (CpfCnpjValidator.validarCNPJ(solicitacao.CpfCnpjSolicitacao) &&
                  UtilizarVinculoCNAEAtividadenaSolicitacao &&
                  UtilizarVinculoCNAEAtividadenaSolicitacao.Valor == "S" &&
                  cnae.Ids.length == 0)
              }
            />
          </Col>
          <Col lg={"2"}>
            <Button
              variant="contained"
              color="primary"
              className={"d-inline mt-4"}
              disabled={
                !form ||
                disableAll ||
                (CpfCnpjValidator.validarCNPJ(solicitacao.CpfCnpjSolicitacao) &&
                  UtilizarVinculoCNAEAtividadenaSolicitacao &&
                  UtilizarVinculoCNAEAtividadenaSolicitacao.Valor == "S" &&
                  cnae.Ids.length == 0)
              }
              onClick={() => this.onSubmit(form)}
            >
              Adicionar
              <i className={"fas fa-plus ml-2"} />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <AtividadeGrid isView={isView} desabilitaExclusao={associacaoAtividade}/>
          </Col>
        </Row>
      </Panel>
    );
  }
}

export default connect({
  actions: {
    atividadeActions,
  },
  selectors: {
    decaSelector,
    cnaeSelector,
    atividadeSelector,
    solicitacaoSelector,
  },
})(Container);
